module.exports = __webpack_public_path__ + "static/media/template_expenses.ffb142b9.csv";